// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-page-ReactPortals-ReactPortals-module-themeProviderWrapper {
	display: inherit;
	height: inherit;
	overflow: inherit;
	width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/csi/page/ReactPortals/ReactPortals.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ","sourcesContent":[".themeProviderWrapper {\n\tdisplay: inherit;\n\theight: inherit;\n\toverflow: inherit;\n\twidth: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeProviderWrapper": `csi-page-ReactPortals-ReactPortals-module-themeProviderWrapper`
};
module.exports = ___CSS_LOADER_EXPORT___;
